import { render, staticRenderFns } from "./BootVueLayout.vue?vue&type=template&id=3ef421a4&scoped=true"
import script from "./BootVueLayout.vue?vue&type=script&lang=js"
export * from "./BootVueLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ef421a4",
  null
  
)

export default component.exports